var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('InfiniteScroll',{attrs:{"is-loading":_vm.isLoading},on:{"reached":_vm.fetchUsersRank}},[_vm._t("default",null,null,{ users: _vm.users, isLoading: _vm.isLoading })],2)}
var staticRenderFns = []

export { render, staticRenderFns }